/**
 * Kinetipath Size Guide finder.
 *
 * Hydrates the [data-kp-finder] widget in sections/size-guide-finder.liquid.
 * Translates a customer's usual US or UK size into the label printed on
 * the PDP size selector, which is the US one. Out-of-range inputs trigger a soft
 * "measure for an exact check" message linking to #size-measure.
 *
 * Vanilla JS, no framework, no storage. State lives in closure vars.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-kp-finder]');
  if (!root) return;

  var selectEl = root.querySelector('[data-size-select]');
  var resultEl = root.querySelector('[data-result]');
  var genderButtons = root.querySelectorAll('[data-gender]');
  var systemButtons = root.querySelectorAll('[data-system]');
  if (!selectEl || !resultEl) return;

  var womenUrl = root.getAttribute('data-women-url') || '/collections/all';
  var menUrl = root.getAttribute('data-men-url') || '/collections/all';
  var showHint = root.dataset.showPdpHint !== 'false';

  var state = { gender: null, system: 'us' };

  var SIZE_OPTIONS = {
    women: {
      us: [5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
      uk: [3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8],
      eu: [36, 37, 38, 39, 40, 41, 42]
    },
    men: {
      us: [7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11],
      uk: [6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10],
      eu: [39, 40, 41, 42, 43, 44, 45, 46]
    }
  };

  var MAPPING = {
    women: {
      us: function (s) { if (s >= 10) return null; if (s >= 8.5) return 2; if (s >= 7)   return 1; return 0; },
      uk: function (s) { if (s >= 8)  return null; if (s >= 7)   return 2; if (s >= 5.5) return 1; return 0; },
      eu: function (s) { if (s >= 41) return null; if (s >= 39)  return 2; if (s >= 38)  return 1; return 0; }
    },
    men: {
      us: function (s) { if (s >= 11) return null; if (s >= 10)  return 2; if (s >= 9)   return 1; return 0; },
      uk: function (s) { if (s >= 10) return null; if (s >= 9)   return 2; if (s >= 8)   return 1; return 0; },
      eu: function (s) { if (s >= 45) return null; if (s >= 43)  return 2; if (s >= 41)  return 1; return 0; }
    }
  };

  var ROWS = {
    women: [
      { us: 'US 6–6.5',   uk: 'UK 4–5',   eu: 'EU 36/37', full: '6-6.5' },
      { us: 'US 7.5–8',   uk: 'UK 5.5–6', eu: 'EU 38/39', full: '7.5-8' },
      { us: 'US 9–9.5',   uk: 'UK 7–7.5', eu: 'EU 40/41', full: '9-9.5' }
    ],
    men: [
      { us: 'US 8–8.5',   uk: 'UK 7–7.5', eu: 'EU 40/41', full: '8-8.5' },
      { us: 'US 9–9.5',   uk: 'UK 8–8.5', eu: 'EU 42/43', full: '9-9.5' },
      { us: 'US 10–10.5', uk: 'UK 9–9.5', eu: 'EU 44/45', full: '10-10.5' }
    ]
  };

  function clearResult() {
    resultEl.innerHTML = '';
  }

  function populateSelect() {
    while (selectEl.firstChild) {
      selectEl.removeChild(selectEl.firstChild);
    }

    if (!state.gender) {
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = "Pick Women's or Men's first";
      placeholder.disabled = true;
      placeholder.selected = true;
      selectEl.appendChild(placeholder);
      selectEl.disabled = true;
      return;
    }

    var ready = document.createElement('option');
    ready.value = '';
    ready.textContent = 'Your usual size';
    ready.disabled = true;
    ready.selected = true;
    selectEl.appendChild(ready);

    var sizes = SIZE_OPTIONS[state.gender][state.system];
    for (var i = 0; i < sizes.length; i++) {
      var opt = document.createElement('option');
      opt.value = String(sizes[i]);
      opt.textContent = String(sizes[i]);
      selectEl.appendChild(opt);
    }

    selectEl.disabled = false;
  }

  function renderResult(gender, system, idx) {
    clearResult();

    if (idx === null) {
      var outCard = document.createElement('div');
      outCard.className = 'size-guide-finder__result-card size-guide-finder__result-card--out';

      var outBody = document.createElement('p');
      outBody.className = 'size-guide-finder__result-body';
      outBody.appendChild(document.createTextNode("You're at the edge of our current size range. Measure your foot for an exact check, or email "));
      var mail = document.createElement('a');
      mail.className = 'size-guide-finder__result-mail';
      mail.href = 'mailto:support@kinetipath.com';
      mail.textContent = 'support@kinetipath.com';
      outBody.appendChild(mail);
      outBody.appendChild(document.createTextNode('.'));
      outCard.appendChild(outBody);

      var ghost = document.createElement('a');
      ghost.className = 'size-guide-finder__result-cta size-guide-finder__result-cta--ghost';
      ghost.href = '#size-measure';
      ghost.textContent = 'Go to the measurement guide ↓';
      outCard.appendChild(ghost);

      resultEl.appendChild(outCard);
      return;
    }

    var row = ROWS[gender][idx];
    var displaySize = row[system];
    var fullLabel = row.full;
    var ctaUrl = gender === 'women' ? womenUrl : menUrl;
    var ctaLabel = gender === 'women' ? "Shop Women's →" : "Shop Men's →";

    var card = document.createElement('div');
    card.className = 'size-guide-finder__result-card';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'size-guide-finder__result-eyebrow';
    eyebrow.textContent = 'Your KinetiPath size';
    card.appendChild(eyebrow);

    var sizeP = document.createElement('p');
    sizeP.className = 'size-guide-finder__result-size';
    var sizeStrong = document.createElement('strong');
    sizeStrong.textContent = displaySize;
    sizeP.appendChild(sizeStrong);
    card.appendChild(sizeP);

    if (showHint) {
      var bodyMain = document.createElement('p');
      bodyMain.className = 'size-guide-finder__result-body';
      bodyMain.appendChild(document.createTextNode('On the product page, select the size labeled '));
      var bodyStrong = document.createElement('strong');
      bodyStrong.textContent = fullLabel;
      bodyMain.appendChild(bodyStrong);
      bodyMain.appendChild(document.createTextNode('.'));
      card.appendChild(bodyMain);
    }

    var hint = document.createElement('p');
    hint.className = 'size-guide-finder__result-body size-guide-finder__result-body--hint';
    hint.textContent = 'Between sizes? Because the sandals are an open design, we round up.';
    card.appendChild(hint);

    var cta = document.createElement('a');
    cta.className = 'size-guide-finder__result-cta';
    cta.href = ctaUrl;
    cta.textContent = ctaLabel;
    card.appendChild(cta);

    resultEl.appendChild(card);
  }

  function compute() {
    var raw = selectEl.value;
    var size = parseFloat(raw);
    if (isNaN(size)) {
      clearResult();
      return;
    }
    if (!state.gender) {
      clearResult();
      return;
    }
    var mapFn = MAPPING[state.gender][state.system];
    var idx = mapFn(size);
    renderResult(state.gender, state.system, idx);
  }

  for (var gi = 0; gi < genderButtons.length; gi++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-gender');
        if (state.gender === next) return;
        state.gender = next;
        for (var j = 0; j < genderButtons.length; j++) {
          genderButtons[j].setAttribute(
            'aria-pressed',
            String(genderButtons[j].getAttribute('data-gender') === next)
          );
        }
        clearResult();
        populateSelect();
      });
    })(genderButtons[gi]);
  }

  for (var si = 0; si < systemButtons.length; si++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-system');
        if (state.system === next) return;
        state.system = next;
        for (var j = 0; j < systemButtons.length; j++) {
          systemButtons[j].setAttribute(
            'aria-pressed',
            String(systemButtons[j].getAttribute('data-system') === next)
          );
        }
        clearResult();
        populateSelect();
      });
    })(systemButtons[si]);
  }

  selectEl.addEventListener('change', compute);

  populateSelect();
})();
